module.exports = __webpack_public_path__ + "img/logo.eb0e891e.png";